export const PAGE_CONTEXTS = [
  { path: '/content-candidates', ko: { title: '콘텐츠 후보', purpose: '추천 후보를 읽고 채택·미채택·삭제로 정리합니다. 판단은 선택한 환경에 저장됩니다.' }, en: { title: 'Content candidates', purpose: 'Review stored candidates and adopt, reject or hide them in the selected environment.' } },
  { path: '/local-events', ko: { title: '지역 행사 검수', purpose: '공식 원문과 PO 편집을 비교하고 영어·장소·일정·표시 기간의 공개 조건을 확인합니다.', unreleasedWarning: 'TEST 관리 API와 로컬 preview를 구분합니다. 로컬 preview는 실제 저장·공개가 아닙니다.' }, en: { title: 'Local event review', purpose: 'Compare official evidence and editorial drafts; review English, venues, schedules and visibility.', unreleasedWarning: 'Distinguish the TEST management API from local preview. Local preview is not a real save or publication.' }, unreleased: true, preserveScope: true },
  { path: '/ads/settings', ko: { title: 'Ads 운영 설정', purpose: '전체 광고 허용·공통 설정과 변경 이력을 확인합니다.' }, en: { title: 'Ads operations settings', purpose: 'Review overall advertising permission, shared settings and change history.' }, related: ['/ads', '/ads/discover'] },
  { path: '/ads/discover', ko: { title: 'Discover 광고', purpose: 'Discover 광고 허용·간격과 성과·전달 실패를 확인합니다.' }, en: { title: 'Discover advertising', purpose: 'Review Discover advertising permission, interval, performance and delivery failures.' }, related: ['/ads', '/ads/settings'] },
  { path: '/ads', ko: { title: 'Ads 대시보드', purpose: '광고 성과·지면 상태·조치 필요를 출처와 집계 상태를 구분하여 확인합니다.' }, en: { title: 'Ads dashboard', purpose: 'Review advertising performance, placement status and required actions with source and availability context.' }, related: ['/ads/settings', '/ads/discover'] },
  { path: '/push/catalog', ko: { title: '알림 목록', purpose: '알림의 의미·담당자·전달 정책을 확인하고 정의를 관리합니다. 정책 허용과 실제 발송을 구분합니다.' }, en: { title: 'Notification catalog', purpose: 'Understand notifications, owners and delivery policies. Policy permission is not runtime delivery evidence.' }, doc: 'features/push', related: ['/push/limits', '/push/history'] },
  { path: '/push/delivery', ko: { title: '발송 현황', purpose: '발송 시도·예산 억제와 계측 공백을 확인합니다.' }, en: { title: 'Delivery overview', purpose: 'Review provider attempts, budget suppression and measurement gaps.' }, doc: 'features/push', related: ['/push/limits'] },
  { path: '/push/limits', ko: { title: '비용·빈도', purpose: '지원하는 대량 알림의 예산·수신자 제한·반복 간격과 실제 적용 상태를 확인합니다.' }, en: { title: 'Cost & frequency', purpose: 'Review budgets, audience limits, intervals and enforcement for supported broadcast paths.' }, doc: 'features/push', related: ['/push/catalog', '/push/delivery'] },
  { path: '/push/history', ko: { title: '변경 이력', purpose: '알림 정의·전달 정책·예산 변경의 책임과 사유를 확인합니다.' }, en: { title: 'Change history', purpose: 'Review actors and reasons for definition, policy and budget changes.' }, doc: 'features/push', related: ['/push/catalog'] },

  { path: '/products/universe', query: { tab: 'landmarks' }, ko: { title: 'Universe 랜드마크 현황', purpose: '현재 배치 설정과 실제 앱 노출의 관측 공백을 확인합니다. 카탈로그 설정은 사용자 노출 증거가 아닙니다.', unreleasedWarning: '미출시 기능입니다. 선택한 TEST/PROD 설정을 조회하며 사용자 앱의 실제 노출 계측은 준비 중입니다.' }, en: { title: 'Universe landmark overview', purpose: 'Review placement settings and app exposure measurement gaps. Catalog settings are not user exposure evidence.', unreleasedWarning: 'Unreleased feature. The selected TEST/PROD settings are available; app exposure measurement is pending.' }, preserveScope: true, unreleased: true, related: ['/landmarks'] },
  { path: '/analytics/growth', ko: { title: '앱 성장', purpose: '웹 방문부터 스토어 이동·다운로드·전체 회원가입까지 기간별 유입 흐름과 수집 상태를 확인합니다.' }, en: { title: 'App growth', purpose: 'Review the period journey from web visits to store clicks, downloads and signups from all sources, with collection states.' }, related: ['/analytics/overview', '/analytics/events', '/products'], preserveScope: true, doc: 'features/analytics' },
  { path: '/products/dm', ko: { title: 'DM 제품별 현황', purpose: '서버의 관리 대상 성공 발신·요청·한도 거절과 관측 공백을 확인합니다.' }, en: { title: 'DM product overview', purpose: 'Review managed server sends, requests, quota rejections and coverage gaps.' }, related: ['/settings/content-usage', '/moderation?tab=DM&target_type=DM', '/cost-scale'] },
  { path: '/products', ko: { title: '제품별 현황', purpose: '제품별로 기록된 이용·행동과 관측 공백을 확인하고 상세 조사로 이동합니다.' }, en: { title: 'Product overview', purpose: 'Review recorded product activity and measurement gaps, then investigate further.' }, related: ['/analytics/events'] },
  {
    "path": "/",
    "ko": {
      "title": "운영 요약",
      "purpose": "현재 운영 상태와 이상 징후를 확인하고 상세 조사로 이동합니다."
    },
    "en": {
      "title": "Operations overview",
      "purpose": "Review service health and follow anomalies into detail."
    },
    "doc": "features/dashboard",
    "related": [
      "/analytics/overview",
      "/service-access",
      "/mobile-release-center/overview"
    ]
  },
  {
    "path": "/analytics/overview",
    "ko": {
      "title": "이용 추세",
      "purpose": "기간별 이용 지표와 이전 기간 대비 변화를 확인합니다."
    },
    "en": {
      "title": "Usage trends",
      "purpose": "Compare usage trends with the preceding period."
    },
    "doc": "features/analytics",
    "related": [
      "/analytics/events",
      "/analytics/crash"
    ]
  },
  {
    "path": "/analytics/events",
    "ko": {
      "title": "이벤트 분석",
      "purpose": "행동별 변화와 플랫폼·앱 버전별 차이를 조사합니다."
    },
    "en": {
      "title": "Events",
      "purpose": "Investigate behavior changes by platform and app version."
    },
    "doc": "features/analytics",
    "related": [
      "/analytics/overview",
      "/analytics/crash"
    ]
  },
  {
    "path": "/analytics/crash",
    "ko": {
      "title": "앱 오류·Crash",
      "purpose": "오류 영향과 안정성 추세를 확인하고 원본 오류 기록으로 이동합니다."
    },
    "en": {
      "title": "App crashes",
      "purpose": "Review stability trends and follow links to source crash evidence."
    },
    "doc": "features/analytics",
    "related": [
      "/mobile-release-center/releases"
    ]
  },
  {
    "path": "/analytics",
    "ko": {
      "title": "이용 분석",
      "purpose": "이용 추세·이벤트·앱 오류를 기간 기준으로 비교합니다."
    },
    "en": {
      "title": "Analytics",
      "purpose": "Compare usage, events and app stability over a defined period."
    },
    "doc": "features/analytics"
  },
  {
    "path": "/cost-scale",
    "ko": {
      "title": "비용·사용량",
      "purpose": "현재 비용·증가 원인과 확장 시나리오를 실측·추정·가정으로 구분합니다."
    },
    "en": {
      "title": "Cost & usage",
      "purpose": "Separate measured costs, estimates and scaling assumptions."
    },
    "related": [
      "/analytics/overview"
    ]
  },
  {
    "path": "/user",
    "ko": {
      "title": "사용자",
      "purpose": "계정 상태와 활동·제재 맥락을 조사합니다. 진단 정보는 별도로 펼쳐 확인합니다."
    },
    "en": {
      "title": "Users",
      "purpose": "Investigate account status, activity and restrictions; expand diagnostics when needed."
    },
    "doc": "features/user-management",
    "related": [
      "/moderation",
      "/ban-history"
    ]
  },
  {
    "path": "/celebs/bubbles",
    "ko": {
      "title": "셀럽 말풍선",
      "purpose": "셀럽 메시지의 노출 상태와 시작·만료 시각을 확인합니다."
    },
    "en": {
      "title": "Celebrity bubbles",
      "purpose": "Review celebrity messages, visibility and expiry."
    },
    "doc": "features/celeb-bubble",
    "related": [
      "/celebs"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/celebs",
    "ko": {
      "title": "셀럽",
      "purpose": "셀럽 유형·파트너 상태와 Fan 관계를 확인합니다."
    },
    "en": {
      "title": "Celebrities",
      "purpose": "Review celebrity type, partner status and fan relationships."
    },
    "doc": "features/celebs",
    "related": [
      "/user",
      "/celebs/bubbles"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/community/threads",
    "ko": {
      "title": "Community 스레드",
      "purpose": "게시물과 작성자·상태를 조회하고 필요한 관리 작업을 수행합니다."
    },
    "en": {
      "title": "Community threads",
      "purpose": "Review threads, authors and publishing state."
    },
    "doc": "features/community",
    "related": [
      "/community/boards",
      "/community/reports"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/community/boards",
    "ko": {
      "title": "Community 보드",
      "purpose": "지역·일반 보드의 구조와 연결 콘텐츠를 확인합니다."
    },
    "en": {
      "title": "Community boards",
      "purpose": "Review regional/general board structure and linked content."
    },
    "doc": "features/community",
    "related": [
      "/community/threads"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/community/reports",
    "ko": {
      "title": "Community 신고",
      "purpose": "Community 신고 원본과 대상·처리 상태를 확인합니다."
    },
    "en": {
      "title": "Community reports",
      "purpose": "Review community report evidence, targets and processing state."
    },
    "doc": "features/community",
    "related": [
      "/report",
      "/moderation"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/community/playground",
    "ko": {
      "title": "Community API 검증",
      "purpose": "요청 대상과 입력·결과를 확인하며 Community API를 검증합니다."
    },
    "en": {
      "title": "Community API QA",
      "purpose": "Verify Community API inputs, targets and results."
    },
    "qa": true,
    "doc": "features/community",
    "related": [
      "/community/nearby",
      "/community/map"
    ],
    "unreleased": true
  },
  {
    "path": "/community/nearby",
    "ko": {
      "title": "주변 조회 검증",
      "purpose": "위치·반경 조건과 주변 콘텐츠 결과를 검증합니다."
    },
    "en": {
      "title": "Nearby query QA",
      "purpose": "Verify nearby content using explicit position and radius conditions."
    },
    "qa": true,
    "doc": "features/community",
    "related": [
      "/community/map",
      "/community/playground"
    ],
    "unreleased": true
  },
  {
    "path": "/community/map",
    "ko": {
      "title": "지도 노출 검증",
      "purpose": "지도와 목록의 콘텐츠·보드 노출을 같은 조건으로 검증합니다."
    },
    "en": {
      "title": "Map exposure QA",
      "purpose": "Verify content/board visibility on map and list."
    },
    "qa": true,
    "doc": "features/community",
    "related": [
      "/community/nearby"
    ],
    "unreleased": true
  },
  {
    "path": "/community",
    "ko": {
      "title": "Community 현황",
      "purpose": "게시·참여 현황을 데이터 출처와 집계 범위를 확인한 뒤 읽습니다."
    },
    "en": {
      "title": "Community overview",
      "purpose": "Read publishing and engagement metrics alongside source and coverage."
    },
    "doc": "features/community",
    "related": [
      "/community/threads",
      "/community/boards",
      "/community/reports"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/plazas",
    "ko": {
      "title": "광장",
      "purpose": "광장의 위치·반경·활성 상태를 지도와 상세에서 확인합니다."
    },
    "en": {
      "title": "Plazas",
      "purpose": "Review plaza location, radius and active state on the map and detail."
    },
    "related": [
      "/service-access"
    ]
  },
  {
    "path": "/report",
    "ko": {
      "title": "신고 접수",
      "purpose": "신고 접수와 심사 Case를 구분하고 대상 콘텐츠·사용자 조사로 연결합니다."
    },
    "en": {
      "title": "Report intake",
      "purpose": "Distinguish report intake from cases and inspect linked content/users."
    },
    "doc": "features/report",
    "related": [
      "/moderation",
      "/user"
    ]
  },
  {
    "path": "/moderation",
    "ko": {
      "title": "콘텐츠 심사",
      "purpose": "유효 신고 신호와 콘텐츠·사용자 맥락을 확인해 조치를 판단합니다."
    },
    "en": {
      "title": "Content review",
      "purpose": "Review valid report signals and content/user context before action."
    },
    "doc": "features/report",
    "related": [
      "/report",
      "/ban-history"
    ]
  },
  {
    "path": "/ban-history",
    "ko": {
      "title": "계정 Ban·해제 이력",
      "purpose": "Ban·해제 조치의 대상·수행자·시각을 확인합니다."
    },
    "en": {
      "title": "Ban & unban history",
      "purpose": "Audit Ban/unban targets, actors and times."
    },
    "doc": "features/ban-history",
    "related": [
      "/user",
      "/moderation"
    ]
  },
  {
    "path": "/push/announcements",
    "ko": {
      "title": "공지 캠페인",
      "purpose": "언어별 메시지·대상·발송 시점과 실제 캠페인 결과를 확인합니다."
    },
    "en": {
      "title": "Announcement campaigns",
      "purpose": "Review localized messages, audience, schedule and campaign results."
    },
    "doc": "features/push",
    "related": [
      "/push/catalog",
      "/push/limits"
    ]
  },
  {
    "path": "/push/catalog",
    "ko": {
      "title": "Push 전달 정책",
      "purpose": "알림 종류별 Inbox·OS Push 전달 gate와 앱 버전 조건을 확인합니다."
    },
    "en": {
      "title": "Push delivery policies",
      "purpose": "Review Inbox/OS push gates and app version conditions per notification."
    },
    "doc": "features/push",
    "related": [
      "/push/limits",
      "/mobile-release-center/policies"
    ]
  },
  {
    "path": "/push/limits",
    "ko": {
      "title": "브로드캐스트 제어",
      "purpose": "예산·사용량·억제 원인과 전달 제한·발신자를 확인합니다."
    },
    "en": {
      "title": "Broadcast controls",
      "purpose": "Review budgets, usage, suppression, delivery limits and senders."
    },
    "doc": "features/push",
    "related": [
      "/push/catalog"
    ]
  },
  {
    "path": "/push/test",
    "ko": {
      "title": "Push 전달 검증",
      "purpose": "실제 수신자와 요청 본문·환경을 확인하고 전달 결과를 검증합니다."
    },
    "en": {
      "title": "Push delivery QA",
      "purpose": "Verify recipients, request body, environment and delivery result."
    },
    "qa": true,
    "doc": "features/push",
    "related": [
      "/push/announcements"
    ]
  },
  {
    "path": "/mobile-release-center/candidates",
    "ko": {
      "title": "출시 후보",
      "purpose": "코드·검토·CI·QA 조건을 비교하고 출시 범위의 확정·이월을 판단합니다."
    },
    "en": {
      "title": "Release candidates",
      "purpose": "Compare code, review, CI and QA before committing or deferring scope."
    },
    "related": [
      "/mobile-release-center/plan",
      "/mobile-release-center/releases"
    ]
  },
  {
    "path": "/mobile-release-center/plan",
    "ko": {
      "title": "출시 계획",
      "purpose": "버전별 포함 항목·담당자·남은 준비 조건을 확인합니다."
    },
    "en": {
      "title": "Release plans",
      "purpose": "Review version scope, owners and remaining readiness conditions."
    },
    "related": [
      "/mobile-release-center/candidates",
      "/mobile-release-center/releases"
    ]
  },
  {
    "path": "/mobile-release-center/content",
    "ko": { "title": "출시 문구", "purpose": "버전별 출시노트·영어 리뷰노트를 편집하고 문구 승인을 확인합니다." },
    "en": { "title": "Release copy", "purpose": "Edit release notes and English review instructions, and review copy approval." },
    "related": ["/mobile-release-center/plan", "/mobile-release-center/releases"]
  },
  {
    "path": "/mobile-release-center/releases",
    "ko": {
      "title": "Store · OTA 실행",
      "purpose": "플랫폼별 실제 공개·적용 상태와 실행·rollback 근거를 확인합니다."
    },
    "en": {
      "title": "Store · OTA execution",
      "purpose": "Review actual platform release/application state and execution evidence."
    },
    "related": [
      "/mobile-release-center/versions"
    ]
  },
  {
    "path": "/mobile-release-center/versions",
    "ko": {
      "title": "앱 버전",
      "purpose": "등록된 버전·build와 실제 출시 단계를 구분해 확인합니다."
    },
    "en": {
      "title": "App versions",
      "purpose": "Distinguish registered versions/builds from released artifacts."
    },
    "doc": "features/app-version",
    "related": [
      "/mobile-release-center/policies"
    ]
  },
  {
    "path": "/mobile-release-center/policies",
    "ko": {
      "title": "업데이트 정책",
      "purpose": "현재 유효한 최소·권장 버전과 사용자 업데이트 영향을 확인합니다."
    },
    "en": {
      "title": "Update policies",
      "purpose": "Review effective minimum/recommended versions and update impact."
    },
    "doc": "features/app-version-policy",
    "related": [
      "/mobile-release-center/versions"
    ]
  },
  {
    "path": "/mobile-release-center",
    "ko": {
      "title": "출시 현황",
      "purpose": "다음 출시 버전·담당 작업과 출시를 막는 조건을 확인합니다."
    },
    "en": {
      "title": "Release overview",
      "purpose": "Review the next release, owned work and blockers."
    },
    "related": [
      "/mobile-release-center/plan",
      "/mobile-release-center/releases"
    ]
  },
  {
    "path": "/service-access",
    "ko": {
      "title": "서비스 접근 제어",
      "purpose": "설정값과 실제 적용 모드·전파 상태·만료 후 동작을 구분합니다."
    },
    "en": {
      "title": "Service access",
      "purpose": "Distinguish configured and active mode, propagation and expiry behavior."
    },
    "related": [
      "/settings/policies",
      "/settings/content-usage"
    ]
  },
  {
    "path": "/settings/content-usage",
    "ko": {
      "title": "콘텐츠 사용 한도",
      "purpose": "적용 한도와 실제 사용 분포·영향·감사 이력을 확인합니다."
    },
    "en": {
      "title": "Content usage limits",
      "purpose": "Review effective limits, usage distribution, impact and audit history."
    },
    "related": [
      "/settings/policies"
    ]
  },
  {
    "path": "/settings/policies",
    "ko": {
      "title": "정책 카탈로그",
      "purpose": "정책 의미·집행 주체·source 검증 상태를 확인하는 읽기 전용 사전입니다."
    },
    "en": {
      "title": "Policy catalog",
      "purpose": "Read policy meaning, enforcement owner and source verification status."
    },
    "related": [
      "/service-access",
      "/settings/content-usage"
    ]
  },
  {
    "path": "/game/rps/play",
    "ko": {
      "title": "게임 플레이 검증",
      "purpose": "참여 페르소나·진행 상태와 게임 결과를 검증합니다."
    },
    "en": {
      "title": "Game play QA",
      "purpose": "Verify persona, game state and results."
    },
    "qa": true,
    "related": [
      "/dm/users",
      "/game/rps"
    ],
    "unreleased": true
  },
  {
    "path": "/game",
    "ko": {
      "title": "게임 규칙·랭킹",
      "purpose": "적용 규칙·보상 한도와 기간별 결과를 확인합니다."
    },
    "en": {
      "title": "Game rules & ranking",
      "purpose": "Review effective rules, reward limits and period results."
    },
    "related": [
      "/game/rps/play"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/dm/users",
    "ko": {
      "title": "사용자 페르소나",
      "purpose": "관리자 계정과 수행 페르소나를 구분해 검증 주체를 선택합니다."
    },
    "en": {
      "title": "User personas",
      "purpose": "Select a test persona while keeping admin identity distinct."
    },
    "qa": true,
    "doc": "features/dm",
    "related": [
      "/dm/conversations",
      "/celeb-room/feed"
    ]
  },
  {
    "path": "/dm/new",
    "ko": {
      "title": "새 DM 검증",
      "purpose": "수행 페르소나와 상대방을 확인한 뒤 대화 생성을 검증합니다."
    },
    "en": {
      "title": "New DM QA",
      "purpose": "Verify acting persona and recipient before creating a conversation."
    },
    "qa": true,
    "doc": "features/dm",
    "related": [
      "/dm/conversations"
    ]
  },
  {
    "path": "/dm/c",
    "ko": {
      "title": "DM 대화 검증",
      "purpose": "발신·수신 주체와 메시지·읽음 상태를 검증합니다."
    },
    "en": {
      "title": "DM conversation QA",
      "purpose": "Verify sender/recipient identity, messages and read state."
    },
    "qa": true,
    "doc": "features/dm",
    "related": [
      "/dm/conversations"
    ]
  },
  {
    "path": "/dm",
    "ko": {
      "title": "DM 목록 검증",
      "purpose": "현재 페르소나의 대화 목록과 최근 메시지 상태를 검증합니다."
    },
    "en": {
      "title": "DM list QA",
      "purpose": "Verify conversation list and latest message state for the acting persona."
    },
    "qa": true,
    "doc": "features/dm",
    "related": [
      "/dm/users",
      "/dm/new"
    ]
  },
  {
    "path": "/celeb-room/follow",
    "ko": {
      "title": "셀럽 관계 검증",
      "purpose": "TEST 페르소나의 파트너 셀럽 팔로우 관계를 검증합니다."
    },
    "en": {
      "title": "Celebrity relationship QA",
      "purpose": "Verify partner follow relationships for a TEST persona."
    },
    "qa": true,
    "doc": "features/celebs",
    "related": [
      "/celeb-room/feed"
    ]
  },
  {
    "path": "/celeb-room",
    "ko": {
      "title": "Celeb Room 검증",
      "purpose": "페르소나의 룸·피드·팬 관계와 메시지 동작을 검증합니다."
    },
    "en": {
      "title": "Celeb Room QA",
      "purpose": "Verify persona room/feed, fan relationships and message behavior."
    },
    "qa": true,
    "doc": "features/celebs",
    "related": [
      "/dm/users"
    ]
  },
  {
    "path": "/season",
    "ko": {
      "title": "Season 시안",
      "purpose": "시즌·이벤트·타일·티켓·공정성·악용 대응의 기존 시안을 확인합니다."
    },
    "en": {
      "title": "Season demo",
      "purpose": "Inspect existing season, event, tile, ticket, fairness and abuse demos."
    },
    "qa": true,
    "demo": true,
    "doc": "features/season"
  },
  {
    "path": "/admin-accounts",
    "ko": {
      "title": "관리자 계정",
      "purpose": "관리자 접근 권한의 발급·활성·회수 상태를 확인합니다."
    },
    "en": {
      "title": "Admin accounts",
      "purpose": "Review issuance, active access and revocation of admin accounts."
    },
    "doc": "guide/auth",
    "related": [
      "/profile"
    ]
  },
  {
    "path": "/profile",
    "ko": {
      "title": "내 계정",
      "purpose": "개인 계정과 비밀번호 변경의 세션 영향을 확인합니다."
    },
    "en": {
      "title": "My account",
      "purpose": "Review personal account and session impact of password changes."
    },
    "doc": "guide/auth"
  },
  {
    "path": "/moderation",
    "ko": {
      "title": "심사 우선순위 정책",
      "purpose": "신고 사유별 심사 순서를 설정합니다. 변경은 자동 삭제나 계정 제재를 수행하지 않습니다."
    },
    "en": {
      "title": "Review priority policy",
      "purpose": "Configure review ordering by report reason; changes never automatically remove content or ban accounts."
    },
    "query": {
      "tab": "Priority settings"
    },
    "related": [
      "/moderation",
      "/report"
    ]
  },
  {
    "path": "/game/rps",
    "ko": {
      "title": "게임 결과·랭킹",
      "purpose": "집계 기간과 참여·보상 결과를 구분해 확인합니다."
    },
    "en": {
      "title": "Game results & ranking",
      "purpose": "Review results and rewards within the selected aggregation period."
    },
    "query": {
      "tab": "ranking"
    },
    "related": [
      "/game/rps/play"
    ],
    "qa": true,
    "unreleased": true
  },
  {
    "path": "/celeb-room/feed",
    "ko": {
      "title": "Celeb Room 피드 검증",
      "purpose": "현재 페르소나에게 노출되는 룸 피드를 검증합니다."
    },
    "en": {
      "title": "Celeb Room feed QA",
      "purpose": "Verify the room feed shown to the acting persona."
    },
    "qa": true,
    "related": [
      "/celeb-room/mine",
      "/dm/users"
    ]
  },
  {
    "path": "/celeb-room/mine",
    "ko": {
      "title": "내 룸 검증",
      "purpose": "페르소나의 룸 소유 관계와 게시·메시지 동작을 검증합니다."
    },
    "en": {
      "title": "Owned room QA",
      "purpose": "Verify persona room ownership, publishing and messaging."
    },
    "qa": true,
    "related": [
      "/celeb-room/feed"
    ]
  },
  {
    "path": "/celeb-room/r",
    "ko": {
      "title": "룸 대화 검증",
      "purpose": "룸 소유자와 현재 페르소나의 관계·권한·메시지 상태를 검증합니다."
    },
    "en": {
      "title": "Room conversation QA",
      "purpose": "Verify room ownership, persona relationships, permissions and messages."
    },
    "qa": true,
    "related": [
      "/celeb-room/feed"
    ]
  },
  {
    "path": "/celeb-room/r",
    "ko": {
      "title": "룸 팬 목록 검증",
      "purpose": "룸과 연결된 팬 목록과 관계를 검증합니다."
    },
    "en": {
      "title": "Room fans QA",
      "purpose": "Verify the fan list and relationships for this room."
    },
    "suffix": "/fans",
    "qa": true,
    "related": [
      "/celeb-room/feed"
    ]
  },
  {
    "path": "/season/events",
    "ko": {
      "title": "시즌 이벤트 시안",
      "purpose": "시즌 이벤트의 기존 고정 데이터를 검토합니다."
    },
    "en": {
      "title": "Season events demo",
      "purpose": "Inspect existing fixed season event data."
    },
    "qa": true,
    "demo": true,
    "doc": "features/season"
  },
  {
    "path": "/season/tiles",
    "ko": {
      "title": "타일·지도 시안",
      "purpose": "타일 상태와 도시 성장의 기존 시안을 검토합니다."
    },
    "en": {
      "title": "Tiles & map demo",
      "purpose": "Inspect the existing tile and city growth demo."
    },
    "qa": true,
    "demo": true,
    "doc": "features/season"
  },
  {
    "path": "/season/tickets",
    "ko": {
      "title": "티켓·Genesis 시안",
      "purpose": "티켓·Genesis 통계의 기존 시안을 검토합니다."
    },
    "en": {
      "title": "Tickets & Genesis demo",
      "purpose": "Inspect existing ticket and Genesis statistics demos."
    },
    "qa": true,
    "demo": true,
    "doc": "features/season"
  },
  {
    "path": "/season/fairness",
    "ko": {
      "title": "참여 공정성 시안",
      "purpose": "참여 시점·24시간 규칙의 기존 시안을 검토합니다."
    },
    "en": {
      "title": "Fairness demo",
      "purpose": "Inspect the existing participation timing and 24-hour rule demo."
    },
    "qa": true,
    "demo": true,
    "doc": "features/season"
  },
  {
    "path": "/season/abuse",
    "ko": {
      "title": "악용·재시도 시안",
      "purpose": "악용 패턴·재시도 규칙의 기존 시안을 검토합니다."
    },
    "en": {
      "title": "Abuse & retry demo",
      "purpose": "Inspect existing abuse patterns and retry rule demos."
    },
    "qa": true,
    "demo": true,
    "doc": "features/season"
  },
  {
    "path": "/landmarks",
    "ko": {
      "title": "랜드마크 설정",
      "purpose": "지도 콘텐츠의 모델·배치·조명과 빌드 포함 목록을 관리합니다. 선택한 TEST/PROD 카탈로그에 적용됩니다.",
      "unreleasedWarning": "출시 준비 중인 기능입니다. 카탈로그 설정은 실제 앱 노출·출시 완료를 의미하지 않습니다."
    },
    "en": {
      "title": "Landmark settings",
      "purpose": "Manage landmark models, placements, lighting and build selection. Changes apply to the selected TEST/PROD catalog.",
      "unreleasedWarning": "Release preparation. Catalog settings do not prove app exposure or release completion."
    },
    "unreleased": true,
    "related": [
      "/plazas"
    ]
  },
  {
    "path": "/profile-interest-catalog",
    "ko": { "title": "프로필 관심사 카탈로그", "purpose": "선택한 환경의 관심사 전체 목록을 초안·검토·게시합니다.", "unreleasedWarning": "환경별 게시 승인과 전체 내용 SHA 확인이 필요합니다. 번역 검수 범위를 확인하세요." },
    "en": { "title": "Profile interest catalog", "purpose": "Manage the complete interest draft, review and publication for the selected environment.", "unreleasedWarning": "Check the approved content and review scope before publishing to the selected environment." },
    "unreleased": true,
    "related": ["/products/profile"]
  }
];

export function getPageContext(pathname, search = '') {
  const params = new URLSearchParams(search);
  return PAGE_CONTEXTS.filter(({path,query,suffix}) =>
    (pathname === path || (path !== '/' && pathname.startsWith(`${path}/`)))
    && (!query || Object.entries(query).every(([key,value]) => params.get(key) === value))
    && (!suffix || pathname.endsWith(suffix))
  ).sort((a,b) => b.path.length - a.path.length || Number(Boolean(b.query || b.suffix)) - Number(Boolean(a.query || a.suffix)))[0];
}
